import { createElement, lazy, Suspense } from 'react';
import { defineTopbarItem } from '../../extensions/topbar';
const Bell = lazy(() => import('./Bell').then((m) => ({ default: m.Bell })));
export default defineTopbarItem({
  id: 'inbox.bell',
  placement: 'end',
  order: 900,
  Component: () => createElement(Suspense, { fallback: null }, createElement(Bell)),
});
